import { Loader } from '@infura/packages.ui/Loader'

export const CreditThroughputSkeleton = () => {
  return (
    <div>
      <Loader className='h-6 w-16' pulse rounded />
      <div className='mt-3 flex items-end gap-1'>
        <Loader className='h-6 w-full' pulse rounded />
      </div>
    </div>
  )
}
